<template>
    <div
        :id="`planItem${itemData.planId}`" 
        class="item" 
        @click="()=>{goPlanLxDetail(itemData); setPlan()}">
        <div class="time_red nowrap" v-if="itemData.remainTime">
            {{ itemData.remainTime }}
        </div>
        <el-tag size="small">{{ itemData.rule == 1 ? $t('planHome.XH'): $t('planHome.DC') }}{{$t('planHome.LX')}}</el-tag>
        <el-tag size="small" @click.stop style="margin-left: 6px">{{ itemData.planId }}</el-tag>
        <h4 class="nowrap" :title="itemData.planName">
            {{ itemData.planName }}
        </h4>
        <div class="time nowrap">
            {{ itemData.beginTime }}<br />
            {{ itemData.endTime }}
        </div>
        <div class="subject nowrap" :title="itemData.paperName">
            {{ itemData.paperName }}
        </div>
        <div v-if="__userData.userType < 2 ">
            <el-button type="primary" size="mini" @click.stop="endPlan" v-show="itemData.status != '2'">{{$t('planHome.JSLX')}}</el-button>
            <span onclick="(function(e){e.stopPropagation()}(event))" style="margin-left: 6px">
                <el-button 
                    type="primary" 
                    size="mini" 
                    @click.native.stop="goNext"
                    :disabled="itemData.status == 0 || itemData.status == 1" 
                    v-auth="[['teacher', 'student'], 'pro']">
                    {{$t('planHome.CKCJ')}}
                </el-button>
            </span>
            <el-button style="margin-left: 6px;" v-auth="[['teacher'], []]" v-show="itemData.status == 2" type="primary" size="mini" @click.stop="deletePlanBtn"> {{$t('planHome.SCJH')}}</el-button>
        </div>
        
        <img class="plam_lx" src="@/assets/image/plan_lx.png"/>
        <img class="status" v-if="lang == 'zh_CN'" :src="imgs[itemData.status]"/>
        <img class="status" v-else :src="imgs_copy[itemData.status]"/>
    </div>
</template>
<script>
import mins from '@/mins/main'
import fetch from '@/api/fetch'
import Vue from 'vue'
import { getQueryParams, queryStringToBase, getStore } from '@/utils/common'
export default {
    name: 'list-item',
    data(){
        return{
            imgs: [
                require('@/assets/image/nostart.png'),
                require('@/assets/image/thisStart.png'),
                require('@/assets/image/end.png'),
            ],
            imgs_copy: [
                require('@/assets/image/Notopened.png'),
                require('@/assets/image/Inprogress.png'),
                require('@/assets/image/Ended.png'),
            ],
            lang: getStore('lang') || 'zh_CN'
        }
    },
    mixins: [mins],
    props: {
        itemData: {
            type: Object,
            default: ()=>({})
        }
    },
    methods:{
        goNext(){
            let { patternLx } = JSON.parse(this.__Base64.decode(queryStringToBase(getQueryParams().q)))
            let q = this.__Base64.encode(JSON.stringify({
                pattern_lx: patternLx,
                planId: this.itemData.planId,
                playerId: this.itemData.playerId
            }))
            sessionStorage.setItem('showFractionUrl', JSON.stringify(this.$route.fullPath))
            if(patternLx == 0){
                this.$router.push(`/showFraction?q=${q}`)
            }else{
                this.$router.push(`/showFractionStudent?q=${q}`)
            }
            
        },
        endPlan(){
            this.$confirm(this.$t('planHome.SFJSDQJH'), this.$t('planHome.TS'), {
                confirmButtonText: this.$t('planHome.QD'),
                cancelButtonText: this.$t('planHome.QX'),
                type: 'warning'
            }).then(() => {
                fetch.planComplete({
                    planId: this.itemData.planId
                }).then(res=>{
                    if(res.code == 0){
                        this.$parent.getList()
                        this.$notify({ title: this.$t('planHome.CZ'), message: this.$t('planHome.CZCG'), type: 'success' });
                    }else{
                        this.$notify({ title: this.$t('planHome.CZ'), message: res.msg || this.$t('planHome.JSJHSB'), type: 'error' });
                    }
                })
            })   
        },
        deletePlanBtn() {
             this.$confirm(this.$t('planHome.SFSCDQJH'), this.$t('planHome.TS'), {
                confirmButtonText: this.$t('planHome.QD'),
                cancelButtonText: this.$t('planHome.QX'),
                type: 'warning'
            }).then(() => {
                fetch.hidePlan({
                    planId: this.itemData.planId
                }).then(res=>{
                    if(res.code == 0){
                        this.$parent.getList()
                        this.$notify({ title: this.$t('planHome.CZ'), message: this.$t('planHome.CZCG'), type: 'success' });
                    }else{
                        this.$notify({ title: this.$t('planHome.CZ'), message: res.msg || this.$t('planHome.SCJHSB'), type: 'error' });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('planHome.YQXSC')
                }); 
            })   
        },
        setPlan(){
            Vue.prototype.__planData = this.itemData
        }
    }
}
</script>
<style scoped lang="scss">
.item{
    width: 28%;
    min-height: 220px;
    background: #FFFFFF;
    border: 1px solid #D5DAED;
    opacity: 1;
    border-radius: 5px;
    position: relative;
    margin: 0 1.2% 64px 0;
    padding: 24px 0 0 24px;
    box-sizing: border-box;
    min-width: 340px;
    overflow: hidden;
    .time_red {
        font-weight: 700;
        color: red;
        margin-bottom: 5px;
    }
    h4 {
        font-size: 16px;
        font-family: Hiragino Sans GB;
        line-height: 19px;
        color: #0D141E;
        letter-spacing: 1px;
        margin: 6px 0 12px 0;
    }
    .time{
        margin: 12px 0;
        font-size: 12px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        line-height: 12px;
        color: #858C96;
        // height: 12px;
    }
    .subject{
        height: 12px;
        font-size: 12px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        line-height: 12px;
        color: #858C96;
    }
    h4, .time, .subject{
        width: 55%;
    }
    /deep/ .el-button{
        margin-top: 20px;
    }
    .plam_lx{
        position: absolute;
        right: 0; bottom: 0;
        min-width: 130px;
        width: 43%;
    }
    .status{
        width: 70px;
        position: absolute;
        top: 6px;
        right: -3px;
    }
}

.item:hover{
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.16);
    cursor: pointer;
    transition: 0.3s;
}
</style>